module.exports = __webpack_public_path__ + "assets/formosa-alt.274c1867.svg";